import PropTypes from 'prop-types';
import { memo } from 'react';
import { Stack } from '@mui/material';

import { NavListRoot } from './NavList';

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

function NavSectionHorizontal({ navConfig, isLoading }) {
  return (
    <Stack direction="row" justifyContent="center" sx={{ bgcolor: 'background.neutral', borderRadius: 1, px: 0.5 }}>
      <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
        {!isLoading &&
          navConfig.map((group) => (
            <Stack key={group.subheader} direction="row" flexShrink={0}>
              {group.items.map((list) => (
                <NavListRoot key={list.title} list={list} />
              ))}
            </Stack>
          ))}
      </Stack>
    </Stack>
  );
}

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default memo(NavSectionHorizontal);
